import { gql, TypedDocumentNode } from '@common/hooks';
import {
  MissionControlComplianceAssignmentsQueryCgResponse,
  MissionControlComplianceAssignmentsQueryVariables,
  MissionControlComplianceFilterSuppliersQueryCgResponse,
  MissionControlComplianceFilterSuppliersQueryVariables,
  MissionControlComplianceStatus,
} from '@common/graphql';

export type MissionControlComplianceStatusType = MissionControlComplianceStatus;

export type MissionControlComplianceAssignment = NonNullable<
  MissionControlComplianceAssignmentsQueryCgResponse['missionControlPaginatedAssignments']['staffingRequestAssignments']
>[number];

export const MISSION_CONTROL_COMPLIANCE_FILTER_SUPPLIERS_QUERY: TypedDocumentNode<
  MissionControlComplianceFilterSuppliersQueryCgResponse,
  MissionControlComplianceFilterSuppliersQueryVariables
> = gql`
  query MissionControlComplianceFilterSuppliers {
    suppliers {
      id
      name
    }
  }
`;

export const MISSION_CONTROL_COMPLIANCE_ASSIGNMENTS_QUERY: TypedDocumentNode<
  MissionControlComplianceAssignmentsQueryCgResponse,
  MissionControlComplianceAssignmentsQueryVariables
> = gql`
  query MissionControlComplianceAssignments(
    $limit: Int!
    $offset: Int!
    $filters: StaffingRequestAssignmentFilterInput
    $orderField: StaffingRequestAssignmentOrderField
    $orderDirection: OrderDirection
  ) {
    missionControlPaginatedAssignments(
      limit: $limit
      offset: $offset
      filters: $filters
      orderField: $orderField
      orderDirection: $orderDirection
    ) {
      staffingRequestAssignments {
        id
        startDate
        worksProfile {
          id
          firstName
          lastName
          fullName
          profilePic
        }
        supplier {
          id
          name
        }
        organizationBusiness {
          id
          name
        }
        organizationUnit {
          id
          name
          clinicalUnit {
            id
            displayName
          }
        }
        hiringLeader {
          id
          name
        }
        staffingRequest {
          id
          role {
            id
            name
            abbreviation
          }
        }
        worksList {
          id
          totalItemsCount
          missingComplianceCount
          missingItemsNames
        }
      }
      totalCount
    }
  }
`;
